import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource-variable/archivo';
import App from './App';
import { loadRuntimeConfig } from './config/runtimeConfig';

const container = document.getElementById('root');
if (!container) throw new Error('Elementul #root lipsește din index.html');

// Config-ul se citește înainte de primul render: providerii îl folosesc sincron.
void loadRuntimeConfig().then(() => {
  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
